import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";
import { Link } from "react-router-dom";
// import "../assets/css/checkout.css";

const Checkout: React.FC = () => {
  const [paymentMethod, setPaymentMethod] = useState("bacs");
  const [openLogin, setOpenLogin] = useState(false);
   const [menuOpen, setMenuOpen] =  useState(false);
    const [showForm, setShowForm] = useState(true);
      const [showPopup, setShowPopup] = useState(false);

  const handlePlaceOrder = (e:any) => {
    e.preventDefault();

    // yaha API call / order save logic laga sakte ho

    setShowPopup(true);
  };

      const [showCoupon, setShowCoupon] = useState(false);
  return (
    
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="checkout-page">
        <Header />
<link rel="stylesheet" href="/assets/css/checkout.css" />
        {/* Hero Section */}
        <section
          className="checkout-banner"
          style={{
            backgroundImage:
              "url('assets/img/bg/breadcumb-bg-4.jpg')",
          }}
        >
          <div className="checkout-overlay">
            <div className="container">
              <div className="checkout-banner-content">
                <h1>CART</h1>

                  <div className="breadcumb-menu-wrap">
            <ul className="breadcumb-menu">
              <li><a href="index.html">Home</a></li>
              <li>Cart</li>
            </ul>
          </div>
              </div>
            </div>
          </div>
        </section>

        {/* Checkout */}
        <section className="checkout-section">
          <div className="container">

           <div className="login-accordion-wrapper">

      {/* Top Box */}
      <div className="top-box">
        <i className="fa-solid fa-circle-exclamation notice-icon"></i>

        <span> Returning Customer? </span>

        <button
          type="button"
          className="login-toggle-btn"
          onClick={() => setOpenLogin(!openLogin)}
        >
          Click Here To Login
        </button>
      </div>

      {/* Accordion Form */}
      {openLogin && (
        <div className="login-form-box">
<div className="row">
          {/* Username */}
          <div className="mb-4 col-md-4 col-lg-4">
            <input
              type="text"
              className="form-control login-input"
              placeholder="Username or email"
            />
          </div>
</div>
<div className="row">
          {/* Password */}
          <div className="mb-4 col-md-4 col-lg-4">
            <input
              type="password"
              className="form-control login-input"
              placeholder="Password"
            />
          </div>
</div>
          {/* Remember */}
          <div className="remember-box">
            <input type="checkbox" id="remember" />

<label htmlFor="remember" className="remember-for">
  Remember Me
</label>
          </div>

          {/* Login Button */}
          <Link
           to="/Login"
           className="vs-btn"
         >
          Login
         </Link>

          {/* Lost Password */}
          <p className="lost-password mt-3 mb-3">
            Lost Your Password?
          </p>

        </div>
      )}

    </div>

            {/* Coupon */}
           <div>

      {/* TOP BOX */}
      <div className="top-box">

        <i className="fa-solid fa-circle-exclamation notice-icon"></i>

        <span>Have A Coupon?</span>

        <button
          type="button"
          className="login-toggle-btn"
          onClick={() => setShowCoupon(!showCoupon)}
        >
          Click Here To Enter Your Code
        </button>

      </div>

      {/* COUPON FORM */}
      {showCoupon && (
    

    <div className="login-form-box">
<div className="row">
          {/* Username */}
          <div className="mb-4 col-md-4 col-lg-4">
            <input
              type="text"
              className="form-control login-input"
              placeholder="Write your coupon code"
            />
          </div>
</div>

          {/* Remember */}
        
          {/* Login Button */}
          <button type="submit" className="login-btn">
       Apply Coupon
          </button>

          {/* Lost Password */}
     

        </div>

   
      )}

    </div>

            {/* Form */}
            <div className="row form-area">

              {/* Billing */}
              <div className="col-lg-6">
                <h2 className="section-title">
                  Billing Details
                </h2>

                <div className="checkout-form">

                  <select className="custom-input">
                    <option>United Kingdom (UK)</option>
                  <option>United State (US)</option>
                  <option>Equatorial Guinea (GQ)</option>
                  <option>Australia (AU)</option>
                  <option>Germany (DE)</option>
                  </select>

                  <div className="row">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="custom-input"
                        placeholder="First Name"
                      />
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        className="custom-input"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>

                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Your Company Name"
                  />

                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Street Address"
                  />

                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Apartment, suite, unit etc. (optional)"
                  />

                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Town / City"
                  />

                  <div className="row">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="custom-input"
                        placeholder="Country"
                      />
                    </div>

                    <div className="col-md-6">
                      <input
                        type="text"
                        className="custom-input"
                        placeholder="Postcode / Zip"
                      />
                    </div>
                  </div>

                  <input
                    type="email"
                    className="custom-input"
                    placeholder="Email Address"
                  />

                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Phone number"
                  />

                <label className="check-label" htmlFor="accountNewCreate">
  <input type="checkbox" id="accountNewCreate" />
  <span>Create An Account?</span>
</label>

                </div>
              </div>

              {/* Shipping */}
        <div className="col-lg-6">

      {/* SHIPPING CHECKBOX */}
      <div className="shipping-head check-label">
<div className="label-checkboxes">
        <input
          type="checkbox"
          id="ship"
          checked={showForm}
          onChange={() => setShowForm(!showForm)}
        />

        <p className="ship-to-a">
          Ship To A Different Address?
        </p>
</div>
      </div>

      {/* WHEN CHECKBOX IS CHECKED */}
      {showForm && (
        <div className="checkout-form">

          <select className="custom-input">
            <option>United Kingdom (UK)</option>
            <option>United State (US)</option>
            <option>Equatorial Guinea (GQ)</option>
            <option>Australia (AU)</option>
            <option>Germany (DE)</option>
          </select>

          <div className="row">

            <div className="col-md-6">
              <input
                type="text"
                className="custom-input"
                placeholder="First Name"
              />
            </div>

            <div className="col-md-6">
              <input
                type="text"
                className="custom-input"
                placeholder="Last Name"
              />
            </div>

          </div>

          <input
            type="text"
            className="custom-input"
            placeholder="Your Company Name"
          />

          <input
            type="text"
            className="custom-input"
            placeholder="Street Address"
          />

          <input
            type="text"
            className="custom-input"
            placeholder="Apartment, suite, unit etc. (optional)"
          />

          <input
            type="text"
            className="custom-input"
            placeholder="Town / City"
          />

          <div className="row">

            <div className="col-md-6">
              <input
                type="text"
                className="custom-input"
                placeholder="Country"
              />
            </div>

            <div className="col-md-6">
              <input
                type="text"
                className="custom-input"
                placeholder="Postcode / Zip"
              />
            </div>

          </div>

          <input
            type="email"
            className="custom-input"
            placeholder="Email Address"
          />

          <input
            type="text"
            className="custom-input"
            placeholder="Phone number"
          />

        </div>
      )}

      {/* WHEN CHECKBOX IS UNCHECKED */}
      {!showForm && (
        <textarea
          className="custom-textarea"
          placeholder="Notes about your order, e.g. special notes for delivery."
        ></textarea>
      )}

    </div>
            </div>

            {/* Order */}
            <div className="order-section">
              <h2 className="section-title">
                Your Order
              </h2>

              <table className="order-table">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Product Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>
                        <div className="checkout-image">
                      <img
                        src="assets/img/products5/product-1-1.png"
                        alt=""
                        className="product-img"
                      />
                      </div>
                    </td>

                 <td className="bmw-text">
  <Link to="/shop" className="cart-productname">
    BMW Car Lexus GS Steering...
  </Link>
</td>
                    <td className="bmw-text">₹200</td>
                    <td className="bmw-text">1</td>
                    <td className="bmw-text">₹200</td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <th>Subtotal</th>
                    <td colSpan={4} className="end-sect">₹200</td>
                  </tr>

                  <tr>
                    <th>Shipping</th>
                    <td colSpan={4} className="end-sect">
                      Enter your address to view shipping options.
                    </td>
                  </tr>

                  <tr className="total-row">
                    <th>Total</th>
                    <td colSpan={4} className="end-sect">₹200</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Payment */}
    <div className="woocommerce-checkout-payment">

      <ul className="wc_payment_methods payment_methods methods">

        {/* Direct Bank Transfer */}
        <li className="wc_payment_method">

          <div className="payment-header">

            <input
              id="payment_method_bacs"
              type="radio"
              className="input-radio"
              name="payment_method"
              value="bacs"
              checked={paymentMethod === "bacs"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />

            <label htmlFor="payment_method_bacs">
              Direct bank transfer
            </label>

          </div>

          {paymentMethod === "bacs" && (
            <div className="payment_box">
              <p>
                Make your payment directly into our bank
                account. Please use your Order ID as the
                payment reference. Your order will not be
                shipped until the funds have cleared in
                our account.
              </p>
            </div>
          )}
        </li>

        {/* Cheque */}
        <li className="wc_payment_method">

          <div className="payment-header">

            <input
              id="payment_method_cheque"
              type="radio"
              className="input-radio"
              name="payment_method"
              value="cheque"
              checked={paymentMethod === "cheque"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />

            <label htmlFor="payment_method_cheque">
              Cheque Payment
            </label>

          </div>

          {paymentMethod === "cheque" && (
            <div className="payment_box">
              <p>
                Please send a check to Store Name,
                Store Street, Store Town,
                Store State / County, Store Postcode.
              </p>
            </div>
          )}
        </li>

        {/* Credit Card */}
        <li className="wc_payment_method">

          <div className="payment-header">

            <input
              id="payment_method_cod"
              type="radio"
              className="input-radio"
              name="payment_method"
              value="cod"
              checked={paymentMethod === "cod"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />

            <label htmlFor="payment_method_cod">
              Credit Card

              <img
                src="assets/img/footer/payments.png"
                alt="payment"
                className="payment-img"
              />
            </label>

          </div>

          {paymentMethod === "cod" && (
            <div className="payment_box">
              <p>
                Pay securely using your credit or
                debit card.
              </p>
            </div>
          )}
        </li>

        {/* Paypal */}
        <li className="wc_payment_method">

          <div className="payment-header">

            <input
              id="payment_method_paypal"
              type="radio"
              className="input-radio"
              name="payment_method"
              value="paypal"
              checked={paymentMethod === "paypal"}
              onChange={(e) =>
                setPaymentMethod(e.target.value)
              }
            />

            <label htmlFor="payment_method_paypal">
              Paypal
            </label>

          </div>

          {paymentMethod === "paypal" && (
            <div className="payment_box">
              <p>
                Pay via PayPal; you can pay with your
                credit card if you don’t have a
                PayPal account.
              </p>
            </div>
          )}
        </li>

      </ul>

      <div className="form-row place-order">
        <button
          type="button"
          className="vs-btn"
          onClick={handlePlaceOrder}
        >
          Place Order
        </button>
      </div>
      

    </div>
          </div>
        </section>

        <Footer />
         {showPopup && (
        <div className="popup-overlay">

          <div className="popup-box">

            {/* CLOSE */}
            <div
              className="close-btn"
              onClick={() => setShowPopup(false)}
            >
              ✕
            </div>

            {/* ICON */}
            <div className="success-icon">✔</div>

            {/* TITLE */}
            <h2>Order Successfully Placed!</h2>

            <p className="text thankyou-shop">
              Thank you for shopping with us.
            </p>

            <p className="text">
              Your order has been confirmed and is being processed.
            </p>

            {/* ORDER ID */}
            <div className="order-id-box">
              <p>Order ID</p>
              <h3>#HH12345</h3>
            </div>

            {/* DATE */}
            <p className="date">
              Placed on: 25 May 2025, 11:30 AM
            </p>

            <p className="sms-text">
              You will receive an email/SMS with your order details.
            </p>

            {/* BUTTONS */}
        <div className="btn-group">

  <Link to="/shop" className="shop-btn" onClick={() => setShowPopup(false)}>
    <i className="bi bi-bag mx-2"></i>
     Back to Shop
  </Link>

  <Link to="/my-orders" className="order-btn" onClick={() => setShowPopup(false)}>
    <i className="bi bi-box-seam mx-2"></i>
     View My Orders
  </Link>

</div>

          </div>

        </div>
      )}
    
      </main>

      <ScrollToTop />
      
    </>
  );
};

export default Checkout;